import { useState, useCallback } from 'react'

type ReturnProps = [string, (newValue?: string) => void]

const useToggleString = (
  values: [string, string],
  initial?: string
): ReturnProps => {
  const [state, setState] = useState(initial || values[0])

  const toggle = useCallback(
    (newValue?: string) =>
      setState((prev) => {
        if (newValue !== undefined && typeof newValue === 'string')
          return newValue
        return prev === values[0] ? values[1] : values[0]
      }),
    [values]
  )
  return [state, toggle]
}

export default useToggleString
